import { Grid } from "@mui/material";
import styled from "styled-components";

export const Label = styled.label`
    color: black;
    padding: 0;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
`;

export const Container = styled(Grid)`
    && {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
    }
`;
